<template>
	<div>
		<div class="filters">
			<el-form :inline="true" :model="form">
				<!-- 编号input -->
				<el-form-item>
					<el-input :placeholder="$t('lang.venue.tip_input_customNo')" v-model="form.customNo"></el-input>
				</el-form-item>
				<!-- 名称input -->
				<!-- <el-form-item>
					<el-input :placeholder="$t('lang.venue.tip_input_customName')" v-model="form.customName"></el-input>
				</el-form-item> -->

				<el-form-item>
					<el-select v-model="form.type">
						<el-option key :label="$t('lang.venue.tip_select_attribute')" value=""></el-option>
						<el-option v-for="(item,index) in attrArr" :key="index" :value="item.num" :label="item.name">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item>
					<el-select @change="selectFirstResource" v-model="form.firstResource">
						<el-option key :label="$t('lang.venue.tip_select_firstResource')" value=""></el-option>
						<el-option v-for="(item,index) in resourceArr" :key="index" :value="item.id" :label="item.name">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item>
					<el-select v-model="form.secResource">
						<el-option key :label="$t('lang.venue.tip_select_secResource')" value=""></el-option>
						<el-option v-for="(item,index) in secResourceArr" :key="index" :value="item.id" :label="item.name">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item>
					<el-select v-model="form.health">
						<el-option key :label="$t('lang.venue.tip_select_health')" value=""></el-option>
						<el-option v-for="(item,index) in healthArr" :key="index" :value="item.num" :label="item.name">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item>
					<el-select v-model="form.status">
						<el-option key :label="$t('lang.venue.tip_select_status')" value=""></el-option>
						<el-option v-for="(item,index) in statusArr" :key="index" :value="item.num" :label="item.name">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item>
					<el-select v-model="form.isContract">
						<el-option key label="是否关联合同" value=""></el-option>
						<el-option v-for="(item,index) in isContractArr" :key="index" :value="item.num" :label="item.name">
						</el-option>
					</el-select>
				</el-form-item>

				<el-button type="primary" @click="commit">{{$t('lang.btn_search')}}</el-button>
			</el-form>
		</div>
		<div>
			<el-card>
				<el-button type="danger" slot="header" :disabled="multipleSelection.length>1?false:true" @click="showDialog">批量修改</el-button>
				<el-button type="primary" slot="header" @click="add()">{{$t('lang.venue.btn_addVenue')}}</el-button>
				<el-table :data="tableData" class="wid100" :row-class-name="tableRowClassName"
					@selection-change="handleSelectionChange"
					:height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109">
					<el-table-column type="selection" width="55"></el-table-column>
					<el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
					</el-table-column>
					<el-table-column prop="customName" :label="$t('lang.venue.label_customName')">
					</el-table-column>
					<el-table-column prop="type" :label="$t('lang.venue.label_attribute')">
						<template slot-scope="scope">
							{{attrLabels[scope.row.type]}}
						</template></el-table-column>
					<!-- <el-table-column prop="area" :label="$t('lang.venue.label_area')"></el-table-column> -->
					<!-- <el-table-column :label="$t('lang.venue.label_endDate')">
						<template slot-scope="scope">
							{{scope.row.endDate | timeYMD }}
						</template>
					</el-table-column> -->
					<el-table-column :label="$t('lang.venue.label_supplierName')" width="160">
						<template slot-scope="scope">
							{{scope.row.supplierInfo? scope.row.supplierInfo.supplierName: '--'}}
						</template>
					</el-table-column>
					<el-table-column label="合同名称" width="260">
						<template slot-scope="scope">
							{{scope.row.contractInfo? scope.row.contractInfo.contractName: '--'}}
						</template>
					</el-table-column>
					<el-table-column label="合同价格" width="120">
						<template slot-scope="scope">
							{{scope.row.contractInfo? scope.row.contractInfo.contractPrice: '--'}}
						</template>
					</el-table-column>
					<el-table-column label="合同是否过期" width="120">
						<template slot-scope="scope">
							<span v-if="!scope.row.endDate">--</span>
							<span v-else-if="scope.row.endDate < nowDate" style="color: red;">已过期</span>
							<span v-else-if="scope.row.endDate>=nowDate">未过期</span>
							
						</template>
					</el-table-column>
					<el-table-column prop="firstResourceName" :label="$t('lang.venue.label_resourceType')"></el-table-column>
					<el-table-column prop="secResourceName" :label="$t('lang.venue.label_secResourceType')"></el-table-column>
					<el-table-column prop="houseName" :label="$t('lang.venue.label_house')"></el-table-column>
					<el-table-column prop="unitName" :label="$t('lang.venue.label_unit')"></el-table-column>
					<el-table-column :label="$t('lang.lab_operation')" fixed="right" :width="require('@/config/enum').opr_width4">
						<template slot-scope="scope">
							<el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
							<el-button class="orange" @click="deleteOne(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
							<el-button @click="record(scope.row)">合同记录</el-button>
							<el-button @click="maintains(scope.row)">报事记录</el-button>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
					:page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
					:page-count="pageCount" />
			</el-card>
		</div>
		<el-dialog title="资源点位记录" :visible.sync="dialogVisible" width="70%">
			<el-table :data="recordTableData" class="wid100" :row-class-name="tableRowClassName1"
					:height="recordTableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109">
					<el-table-column type="index" :index="indexMethod1" align="center" :label="$t('lang.lab_index')" width="100px">
					</el-table-column>
					<el-table-column prop="venue.customName" label="资源点位名称"></el-table-column>
					<el-table-column prop="venueSupplier.supplierName" label="供应商名称"></el-table-column>
					<el-table-column prop="venueContract.contractName" label="合同名称"></el-table-column>
					<el-table-column label="合同生效日期">
						<template slot-scope="scope">
							{{scope.row.venueContract.startDate | timeYMD }}
						</template>
					</el-table-column>
					<el-table-column label="合同截止日期">
						<template slot-scope="scope">
							{{scope.row.venueContract.endDate | timeYMD }}
						</template>
					</el-table-column>
				</el-table>
				<el-pagination @size-change="handleSizeChange1" @current-change="handleCurrentChange1" :current-page="pageNo1"
					:page-sizes="[10, 20, 30, 50]" :page-size="pageSize1" layout="sizes, prev, pager, next, jumper"
					:page-count="pageCount1" />
		</el-dialog>
		<el-dialog title="批量修改" :visible.sync="dialogVisible1" width="30%">
			<el-form :model="batch" :rules="rules" ref="batch">
				<el-form-item label="供应商" label-width="120px" prop="supplierId">
					<el-select v-model="batch.supplierId" @change="selectSupplier" placeholder="请选择供应商">
						<el-option v-for="(item,index) in supplierList" :key="index" :value="item.id" :label="item.supplierName">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="合同" label-width="120px" prop="contractId">
					<el-select v-model="batch.contractId" @change="selectContract" placeholder="请选择合同">
						<el-option v-for="(item,index) in contractList" :key="index" :value="item.id" :label="item.contractName">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible1 = false">{{$t('lang.btn_cancel')}}</el-button>
				<el-button type="primary" @click="batchEditSave()">{{$t('lang.btn_save')}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	var nowDate = new Date().getTime()
	export default {
		name: '/manage/main.venueList',
		data() {
			return {
				pageCount: 0, // 总页数
				pageNo: 1, // 页数
				pageSize: 10, // 每页显示数量
				multipleSelection: [], // 多选框
				venueManagecheckbox: require('@/config/enum').venueManagecheckbox, // 是否隐藏复选框
				tableData: [], // 列表数据
				attrArr: [{
					num: 1,
					name: '租赁'
				}, {
					num: 2,
					name: '自营'
				}, {
					num: 3,
					name: '合作'
				}, {
					num: 4,
					name: '内部服务'
				}],
				attrLabels: ['--', '租赁', '自营', '合作', '内部服务'],
				healthArr: [{
					num: 1,
					name: '健康'
				}, {
					num: 0,
					name: '良好'
				}, {
					num: -1,
					name: '损坏'
				}],
				statusArr: [{
					num: 1,
					name: '营业'
				}, {
					num: 0,
					name: '未营业'
				}],
				isContractArr: [{
					num: 1,
					name: '是'
				}, {
					num: 0,
					name: '否'
				}],
				resourceArr: [],
				secResourceArr: [],
				gardenArr: [],
				houseArr: [],
				unitArr: [],
				form: {
					customNo: '',
					customName: '',
					type: '',
					firstResource: '',
					secResource: '',
					supplierName: '',
					gardenId: '',
					houseId: '',
					unitId: '',
					health: '',
					status: '',
					isContract: '',
				},
				dialogVisible: false,
				dialogVisible1: false,
				pageCount1: 0, // 总页数
				pageNo1: 1, // 页数
				pageSize1: 10, // 每页显示数量
				recordTableData: [], // 资源点位记录数据
				rowData: '', // 选中资源点位数据
				supplierList: [], // 供应商列表
				contractList: [], // 合同列表
				batch: {
					supplierId: '', // 选择供应商id
					contactName: '', // 选择供应商负责人姓名
					contactNumber: '', // 选择供应商负责人电话
					contractId: '', // 选择合同id
					basePrice: '', // 选择合同价格
					startDate: '', // 选择合同开始日期
					endDate: '', // 选择合同截止日期
				},
				rules: {
					supplierId: [{
						required: true,
						message: '请选择供应商',
						trigger: 'change'
					}],
					contractId: [{
						required: true,
						message: '请选择合同',
						trigger: 'change'
					}]
				},
				nowDate: new Date().getTime(), // 当前时间戳
			}
		},
		watch: {
			'form.firstResource': function (newVal, oldVal) {
				this.form.secResource = ''
			}
		},
		created() {
			this.form.gardenId = this.$store.getters.gardenId
			let jsonStr = window.localStorage.getItem('venueSearchForm')
			console.log('jsonStr : ' + jsonStr)
			if (jsonStr) {
				this.form = JSON.parse(jsonStr)
				if (window.localStorage.getItem('venueSearchPageNo')) {
					this.PageNo = parseInt(window.localStorage.getItem('venueSearchPageNo'))
				}
			}
			setTimeout(() => {
				window.localStorage.setItem('venueSearchForm', '')
			}, 200)
			this.getData()
			this.getSupplierList()
		},
		activated() {
			this.getData()
			this.getSupplierList()
		},
		methods: {
			getData() {
				let loading = this.$loading()
				let url = `/venue/getList?pageSize=${this.pageSize}&pageNo=${this.pageNo}`
				if (this.form.customNo) {
					url += '&customNo=' + this.form.customNo
				}
				if (this.form.customName) {
					url += '&customName=' + this.form.customName
				}
				if (this.form.type) {
					url += '&type=' + this.form.type
				}
				if (this.form.firstResource) {
					url += '&firstResource=' + this.form.firstResource
				}
				if (this.form.secResource) {
					url += '&secResource=' + this.form.secResource
				}
				if (this.form.supplierName) {
					url += '&supplierName=' + this.form.supplierName
				}
				if (this.form.gardenId) {
					url += '&gardenId=' + this.form.gardenId
				}
				if (this.form.houseId) {
					url += '&houseId=' + this.form.houseId
				}
				if (this.form.unitId) {
					url += '&unitId=' + this.form.unitId
				}
				if (this.form.health) {
					url += '&health=' + this.form.health
				}
				if (this.form.status) {
					url += '&status=' + this.form.status
				}
				if (this.form.isContract === 1 || this.form.isContract === 0) {
					url += '&isContract=' + this.form.isContract
				}
				this.$get(url)
					.then(res => {
							loading.close()
							console.log(res)
							this.tableData = res.list
							this.pageCount = res.pageCount
						},
						error => {
							loading.close()
							this.$message.error(error)
						})
				this.getResource(0)
			},
			getResource(parentId) {
				let loading = this.$loading()
				this.$get('/venue/getTypes' + (parentId > 0 ? ('?parentId=' + parentId) : ''))
					.then(res => {
							if (parentId > 0) {
								loading.close()
								this.secResourceArr = res.list
							} else {
								this.resourceArr = res.list
							}
						},
						error => {
							if (parentId > 0) {
								loading.close()
							}
							this.$message.error(error)
						})
			},
			selectFirstResource(value) {
				if (value) {
					console.log('First : ' + value)
					this.getResource(value)
				}
			},
			// 表格斑马
			tableRowClassName({
				row,
				rowIndex
			}) {
				return rowIndex % 2 === 0 ? 'row-dark' : ''
			},
			// 表格斑马
			tableRowClassName1({
				row,
				rowIndex
			}) {
				return rowIndex % 2 === 0 ? 'row-dark' : ''
			},
			// 多选框
			handleSelectionChange(val) {
				console.log(val)
				this.multipleSelection = val
			},
			add() {
				window.localStorage.setItem('venueSearchForm', JSON.stringify(this.form))
				window.localStorage.setItem('venueSearchPageNo', this.pageNo)
				this.$router.push({
					name: 'venueForm',
					query: {
						flag: true
					}
				})
			},
			edit(rowData) {
				window.localStorage.setItem('venueSearchForm', JSON.stringify(this.form))
				window.localStorage.setItem('venueSearchPageNo', this.pageNo)
				console.log('rowData json : ' + JSON.stringify(rowData))
				console.log(rowData)
				this.$router.push({
					name: 'venueForm',
					query: {
						flag: false,
						venueData: rowData,
					}
				})
			},
			// 更新
			commit() {
				this.pageNo = 1
				this.getData()
			},
			// 监听关闭dialog
			handleDialogClosed() {
				this.resetForm()
			},
			// 翻页
			handleCurrentChange(val) {
				this.pageNo = val
				this.getData()
			},
			handleCurrentChange1(val) {
				this.pageNo1 = val
				this.record(this.rowData)
			},
			// 切换每页显示多少数据
			handleSizeChange(val) {
				this.pageNo = 1
				this.pageSize = val
				this.getData()
			},
			handleSizeChange1(val) {
				this.pageNo1 = 1
				this.pageSize1 = val
				this.record(this.rowData)
			},
			deleteOne(id) {
				let loading = this.$loading()
				this.$confirm(this.$i18n.t('lang.lab_isdelete'), this.$i18n.t('lang.lab_prompt'), {
						confirmButtonText: this.$i18n.t('lang.btn_confirm'),
						cancelButtonText: this.$i18n.t('lang.btn_cancel'),
						type: 'warning'
					}).then(() => {
						this.$delete(`/venue/deleteVenue?id=` + id).then(
							res => {
								loading.close()
								if (res && res.errCode === 0) {
									this.$message({
										type: 'success',
										message: this.$i18n.t('lang.lab_del_success')
									})
									this.commit()
								}
							},
							error => {
								loading.close()
								this.$message.error(error)
							}
						)
					})
					.catch(() => {
						loading.close()
						this.$message({
							type: 'info',
							message: this.$i18n.t('lang.lab_del_can')
						})
					})
			},
			// ID序号功能
			indexMethod(index) {
				return (this.pageNo - 1) * this.pageSize + index + 1
			},
			indexMethod1(index) {
				return (this.pageNo1 - 1) * this.pageSize1 + index + 1
			},
			// 记录
			record(row) {
				this.dialogVisible = true
				this.rowData = row
				console.log(row)
				let loading = this.$loading()
				let url = `/venueLog?venueId=` + row.id + `&pageSize=${this.pageSize1}&pageNo=${this.pageNo1}`
				this.$get(url)
					.then(res => {
							loading.close()
							console.log(res)
							this.recordTableData = res.list
							this.pageCount1 = res.pageCount
						},
						error => {
							loading.close()
							this.$message.error(error)
						})
			},
			// 获取供应商列表
			getSupplierList() {
				this.$get(`/venueSupplier?pageSize=999&pageNo=1`).then(
					res => {
						if (res && res.errCode === 0) {
							console.log(res)
							this.supplierList = res.list
						}
					},
					error => {
						this.$message.error(error)
					}
				)
			},
			// 选择供应商
			selectSupplier(e) {
				this.batch.supplierId = e
				this.batch.contactName = this.supplierList.find(item => {
					return item.id == e
				}).contactName
				this.batch.contactNumber = this.supplierList.find(item => {
					return item.id == e
				}).contactNumber
				this.getContractList(e)
				this.batch.contractId = ''
				this.batch.basePrice = ''
				this.batch.startDate = ''
				this.batch.endDate = ''
			},
			// 获取合同列表
			getContractList(e) {
				this.$get(`/venueContract?contractSupplier=` + e + `&pageSize=9999&pageNo=1`).then(
					res => {
						if (res && res.errCode === 0) {
							console.log(res)
							this.contractList = res.list
						}
					},
					error => {
						this.$message.error(error)
					}
				)
			},
			// 选择合同
			selectContract(e) {
				console.log(e)
				if (this.batch.supplierId == '') {
					this.$message.info('请先选择供应商')
					this.batch.contractId = ''
					return
				}
				this.batch.contractId = e
				this.batch.basePrice = this.contractList.find(item => {
					return item.id == e
				}).contractPrice
				this.batch.startDate = this.contractList.find(item => {
					return item.id == e
				}).startDate
				this.batch.endDate = this.contractList.find(item => {
					return item.id == e
				}).endDate
				// 合同到期提示
				if (nowDate > this.batch.endDate) {
					this.$message.error('合同已过期，请重新选择合同')
				}
			},
			// 批量修改弹窗显示
			showDialog() {
				this.dialogVisible1 = true
			},
			// 批量修改
			batchEditSave() {
				this.$refs.batch.validate((valid) => {
					if (valid) {
						for (let index in this.multipleSelection) {
							let id = this.multipleSelection[index].id
							console.log(this.multipleSelection[index].contractId)
							let isUpdataLog = false
							if (this.multipleSelection[index].contractId != this.batch.contractId) {
								isUpdataLog = true
							}
							this.batchEdit(id, this.batch, index, isUpdataLog)
						}
					} else {
						return false
					}
				})
			},
			// 修改资源点位
			batchEdit(id, batch, index, isUpdataLog) {
				let that = this
				let loading = this.$loading()
				let params = {
					id: id,
					gardenId: that.$store.getters.gardenId,
					supplierId: batch.supplierId,
					contractId: batch.contractId,
					contactName: that.batch.contactName,
					contactNumber: that.batch.contactNumber,
					basePrice: that.batch.basePrice,
					startDate: that.batch.startDate,
					endDate: that.batch.endDate,
				}
				that.$patch(`/venue/updateVenueAll`, params).then(
					res => {
						loading.close()
						if (res && res.errCode === 0) {
							if (isUpdataLog) {
								// 上传记录
								that.updataLog(id, batch.supplierId, batch.contractId)
							}
							if (index - 0 + 1 == that.multipleSelection.length) { 
								that.$message.success('批量修改成功') 
								that.dialogVisible1 = false
								setTimeout(function() {
									that.getData()
									that.batch.supplierId = ''
									that.batch.contactName = ''
									that.batch.contactNumber = ''
									that.batch.contractId = ''
									that.batch.basePrice = ''
									that.batch.startDate = ''
									that.batch.endDate = ''
								}, 500)
							}
						} else if (res && res.errCode != 0) {
							if (index - 0 + 1 == that.multipleSelection.length) { 
								that.$message.error(res.errMsg)
							}
						}
					},
					error => {
						loading.close()
						if (index - 0 + 1 == this.multipleSelection.length) { 
							this.$message.error(error)
						}
					}
				)
			},
			// 上传记录
			updataLog(venueId, supplierId, contractId) {
				let params = {
							venueId: venueId, // 资源点位id
							supplierId: supplierId, // 供应商id
							contractId: contractId, // 合同id
						}
				let loading = this.$loading()
				this.$post(`/venueLog`, params).then(
					res => {
						loading.close()
						if (res && res.errCode === 0) {
							console.log('上传记录成功')
						} else if (res && res.errCode != 0) {
							this.$message.error(res.errMsg)
						}
					},
					error => {
						loading.close()
						this.$message.error(error)
					}
				)
			},
			// 报事记录
			maintains(row) {
				console.log(row)
				this.$router.push({
					name: 'projectWideRepoInfoList',
					query: {
						venueId: row.id,
					}
				})
			}
		}
	}
</script>

<style>
</style>